// LEGACY: Uses SCSS with CSS modules. New code should use @metarouter-private/mr-mui components instead.
// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
/* eslint-disable filename-export/match-default-export */

import pt from 'prop-types';
import React from 'react';

import { MrH, MrInputCheckbox, MrWithTooltip } from '@ion/components';
import { Accordion, AccordionDetails, AccordionSummary } from '@metarouter-private/mr-mui';
import AnalyticsBuilderAdvancedSettings, { STORAGE_TYPE } from './analytics-builder-advanced-settings';
import s from './index.module.scss';

const AnalyticsBuilderAdvancedSettingsAccordion = ({
  formState,
  setField,
  validateField,
  resetError,
  isStandAloneSync,
  isUnminifyFileEnabled,
  isBotDetectionEnabled,
}) => {
  return (
    <Accordion color="neutral" defaultExpanded>
      <AccordionSummary aria-controls="panel1-content" id="panel1-header">
        <MrH h="h5" sans styleNames="noMargin">
          Advanced Settings
        </MrH>
      </AccordionSummary>
      <AccordionDetails>
        {isUnminifyFileEnabled && (
          <div className={s.checkboxContainer}>
            <MrInputCheckbox
              value={formState.unminifyFile?.value ?? false}
              labelPosition="right"
              onChange={setField}
              name="unminifyFile"
              label="Unminify File"
              className={s.checkbox}
            />
            <p className={s.checkboxHelperText}>Human readable format of the file (larger size)</p>
          </div>
        )}
        <div className={s.checkboxContainer}>
          <MrInputCheckbox
            value={formState.fileCompression?.value ?? false}
            labelPosition="right"
            onChange={setField}
            name="fileCompression"
            label="File compression"
            className={s.checkbox}
          />
          <p className={s.checkboxHelperText}>Reduce the file size with compression</p>
        </div>
        {!isStandAloneSync && (
          <div className={s.checkboxContainer}>
            <MrWithTooltip message="Allow MetaRouter to set HTTP (server) cookies on user browsers in addition to javascript cookies. This improves the lifetime of the MetaRouter anonymousId in certain contexts where javascript cookies are limited. It only runs in Safari and other WebKit browsers, including every iOS browser. Note that a visitor's first page load may wait briefly for the sync.">
              <MrInputCheckbox
                value={formState.httpCookie?.value ?? false}
                labelPosition="right"
                onChange={setField}
                name="httpCookie"
                label="Activate Enhanced Tracking with HTTP Cookies"
                className={s.checkbox}
              />
            </MrWithTooltip>
            <p className={s.checkboxHelperText}>
              Increase cookie lifetime in Safari. Syncs once, then refreshes in the background.
            </p>
          </div>
        )}
        {isBotDetectionEnabled && (
          <div className={s.checkboxContainer}>
            <MrWithTooltip message="When enabled, suspected bot traffic will be excluded based on behavior patterns and known bot lists.">
              <MrInputCheckbox
                value={formState.botFilterEnabled?.value ?? false}
                labelPosition="right"
                onChange={setField}
                name="botFilterEnabled"
                label="Enable Bot filtering"
                className={s.checkbox}
              />
            </MrWithTooltip>
            <p className={s.checkboxHelperText}>Filter out automated bot traffic to ensure accurate analytics</p>
          </div>
        )}
        <AnalyticsBuilderAdvancedSettings
          storageTypeValue={formState?.storageType?.value ?? STORAGE_TYPE.TLD_COOKIES}
          formState={formState}
          setField={setField}
          validateField={validateField}
          resetError={resetError}
        />
      </AccordionDetails>
    </Accordion>
  );
};

AnalyticsBuilderAdvancedSettingsAccordion.propTypes = {
  formState: pt.object,
  setField: pt.func,
  validateField: pt.func,
  resetError: pt.func,
  storageTypeValue: pt.string,
  isStandAloneSync: pt.bool,
  isUnminifyFileEnabled: pt.bool,
  isBotDetectionEnabled: pt.bool,
};

export default AnalyticsBuilderAdvancedSettingsAccordion;
